/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Expense_SyncInputs */

const vi_nav_expense_sync = /** @type {(inputs: Nav_Expense_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đồng bộ từ ngân hàng`)
};

/**

* @param {Nav_Expense_SyncInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_expense_sync = /** @type {((inputs?: Nav_Expense_SyncInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Expense_SyncInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_expense_sync(inputs)
});